// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 198 ? "BaseRoutes" : chunkId) + "." + {"70":"ed6e7e80","198":"9913adf8","448":"cd558eb5","554":"b880a725","971":"ace0fc1f"}[chunkId] + ".chunk.css";
};